import React from 'react';

export interface StatDescriptionProps {
  description: string;
  className?: string;
}

export const StatDescription = ({
  description,
  className = '',
}: StatDescriptionProps) => {
  return (
    <div className={`text-white/90 text-xs font-medium px-1 line-clamp-2 ${className}`}>
      {description}
    </div>
  );
};

